import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";

export const fetchResources = (
  meetingId: string,
  setMeetingResources: Function,
  language: string,
  callback?: Function
) => {
  ApiService.get(`meetings/${meetingId}/resources?fetch_author=true`)
    .then((resp) => {
      setMeetingResources(resp.data.meeting_resources);
    })
    .catch((error) => {
      console.error("Error fetching resources", error);
      alert(translate(language, "PAGES.MEETING.RESOURCES.ERROR.FETCH"));
    })
    .finally(() => callback?.());
};

export const createResource = (
  meetingId: string,
  language: string,
  setSubmitLoading: Function,
  name: string,
  url: string,
  isPublic: boolean,
  successCallback?: Function
) => {
  setSubmitLoading(true);
  ApiService.post(`meetings/${meetingId}/resources`, {
    name,
    url,
    is_public: isPublic,
  })
    .then((_) => {
      alert(translate(language, "PAGES.MEETING.RESOURCES.SUCCESS.CREATE"));
      successCallback?.();
    })
    .catch((error) => {
      console.error("Error creating resource", error);
      alert(translate(language, "PAGES.MEETING.RESOURCES.ERROR.CREATE") + error.data.error.message);
    })
    .finally(() => setSubmitLoading(false));
};

export const editResource = (
  meetingId: string,
  resourceId: string,
  language: string,
  setSubmitLoading: Function,
  name: string,
  url: string,
  isPublic: boolean,
  successCallback?: Function
) => {
  setSubmitLoading(true);
  ApiService.put(`meetings/${meetingId}/resources/${resourceId}`, {
    name,
    url,
    is_public: isPublic,
  })
    .then((_) => {
      alert(translate(language, "PAGES.MEETING.RESOURCES.SUCCESS.EDIT"));
      successCallback?.();
    })
    .catch((error) => {
      console.error("Error editing resource", error);
      alert(translate(language, "PAGES.MEETING.RESOURCES.ERROR.EDIT") + error.data.error.message);
    })
    .finally(() => {
      setSubmitLoading(false);
    });
};

export const deleteResource = (meetingId: string, resourceId: string, language: string, successCallback?: Function) => {
  ApiService.delete(`meetings/${meetingId}/resources/${resourceId}`)
    .then((_) => {
      alert(translate(language, "PAGES.MEETING.RESOURCES.SUCCESS.DELETE"));
      successCallback?.();
    })
    .catch((error) => {
      console.error("Error deleting resource", error);
      alert(translate(language, "PAGES.MEETING.RESOURCES.ERROR.DELETE") + error.data.error.message);
    });
};
